/**
 * PEC module constants.
 * Shared within the client pec module only.
 */

export const DEFAULT_COLORS = ['#ef4444', '#f97316', '#eab308', '#83E279', '#10b981'] as const
